import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import './index.scss'

function ProgressBar({ max, value, timeLeft, label, width }) {
  const [percentage, setPercentage] = useState(0)
  const style = { opacity: 1, width: `${percentage}%` }

  useEffect(() => {
    if (value <= max) {
      const perc = parseInt((value / max) * 100)
      setPercentage(isNaN(perc) ? 0 : perc)
    }
  }, [value])

  return (
    <div className='flex-parent flex-start'>
      <div className='flex-child two' style={{ width }}>
        <div className='progress'>
          <div className='progress-done' style={style}>
            <span>{percentage}%</span>
            {timeLeft && percentage >= 60 && percentage < 100 && (
              <span>{timeLeft}m</span>
            )}
          </div>
          {label && <div className='progress-text'>{label}</div>}
        </div>
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  /* The value of the progression */
  value: PropTypes.number.isRequired,
  /* The maxvalue of the progression. If not passed, the default is 100 */
  max: PropTypes.number,
  /* The time left showed in the progress bar if the percentage is > 60  */
  timeLeft: PropTypes.number,
  /* A descriptive label showed below the progress bar */
  label: PropTypes.string,
  /* Width of the progressBar, the default is 120px */
  width: PropTypes.string
}

ProgressBar.defaultProps = {
  max: 100,
  width: '120px'
}

export default ProgressBar
